import {useLegacyGrpcRequest} from '@aboutyou/data-fetcher';
import {Customer_getCustomerLazy} from '@aboutyou/grpc-clients/grips/protos/deprecated/customer.grpc.lazy';
import {CustomerResponse} from '@aboutyou/grpc-clients/grips/protos/deprecated/customer.types';
import {createDataStore} from '../createDataStore';
import {useUserToken} from '../userStore/user.selector';

const useExpensiveCustomerResponse = () => {
  const authToken = useUserToken();

  return useLegacyGrpcRequest(
    Customer_getCustomerLazy,
    {
      session: {
        authToken: authToken!,
      },
    },
    {
      disabled: !authToken,
      keepPreviousData: false,
    },
  );
};

const {Provider, useData: useCustomerResponse} = createDataStore<
  CustomerResponse | undefined
>({
  defaultValue: undefined,
  useQueryHook: useExpensiveCustomerResponse,
});

export {Provider as CustomerProvider, useCustomerResponse};
